import { render, staticRenderFns } from "./BranchDashboard.vue?vue&type=template&id=8f8b04cc&scoped=true"
import script from "./BranchDashboard.vue?vue&type=script&lang=js"
export * from "./BranchDashboard.vue?vue&type=script&lang=js"
import style0 from "./BranchDashboard.vue?vue&type=style&index=0&id=8f8b04cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8b04cc",
  null
  
)

export default component.exports